import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { EmployeeOperationCardListing, EmployeeOperationCardAddEdit } from './Pages/';

export const EmployeeOperationCardRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={EmployeeOperationCardListing} />
        <Route exact path = {`${match.path}/AddEdit`} component={EmployeeOperationCardAddEdit} />
    </Fragment>
)